export enum RoleComponentSubscription {
  SUPERSWEET_ENTRY = 'Supersweet Entry User',
  GIFT_CARD_ADMIN = 'Gift Card Admin',
}